// Redux
import { combineReducers } from "redux";

// Reducers
import { VisitorTypeReducer } from "../VisitorType/reducers/visitorType.reducer";
import { GeographyReducer } from "../Geography/reducers/geography.reducer";
import { EthnicityReducer } from "../Ethnicity/reducers/ethnicity.reducer";
import { GenderReducer } from "../Gender/reducers/gender.reducer";
import { AgeReducer } from "../Age/reducers/age.reducer";

export const DemographicsReducer = combineReducers({
  visitorType: VisitorTypeReducer,
  geography: GeographyReducer,
  ethnicity: EthnicityReducer,
  gender: GenderReducer,
  age: AgeReducer
});

